import { render } from "./FilterKabupatenKotaKecamatan.vue?vue&type=template&id=1728f689"
import script from "./FilterKabupatenKotaKecamatan.vue?vue&type=script&lang=js"
export * from "./FilterKabupatenKotaKecamatan.vue?vue&type=script&lang=js"
script.render = render

export default script